import React, { Fragment, useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useParams, useLocation } from 'react-router-dom';
import NavbarS3 from '../../components/NavbarS3/NavbarS3';
import PageTitle from '../../components/pagetitle/PageTitle';
import { addToCart } from "../../store/actions/action";
import ShopProduct from '../../components/ShopProduct';
import PopupQuickview from '../../components/PopupQuickview/PopupQuickview';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo2.svg';
import { useTranslation } from 'react-i18next';
import MessengerChatButton from '../../components/Messenger/ChatSection';

const ShopPage = ({ addToCart }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const params = useParams();
  const [productsArray, setProductsArray] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const productsPerPage = 12;

  const API_URL = process.env.REACT_APP_API_URL;

  // Fetch products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_URL}/api/products`, {
          method: 'GET',
          headers: { 'Accept': 'application/json' },
        });
        console.log('Response status:', res.status);
        if (!res.ok) throw new Error(`Can't reach: ${res.status}`);
        const data = await res.json();

        const products = Array.isArray(data) ? data : data ? [data] : [];
        console.log('Fetched products:', products); // Debug

        const uniqueCategories = ['All', ...new Set(products.map((p) => p.category))];
        console.log('Available categories:', uniqueCategories); // Debug

        setCategories(uniqueCategories);
        setProductsArray(products);
      } catch (err) {
        console.error('Fetch error:', err);
        setError(err.message || 'Backend-с дата татахад алдаа гарлаа');
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  // Update selectedCategory based on URL params
  useEffect(() => {
    if (productsArray.length === 0 || categories.length === 0) return; // Wait for data

    let categoryFromUrl = null;
    if (params.category) {
      categoryFromUrl = decodeURIComponent(params.category);
      console.log('Path category (decoded):', categoryFromUrl);
    }

    // Set category based on URL
    if (categoryFromUrl) {
      const normalizedParam = categoryFromUrl.trim().replace(/\b\w/g, l => l.toUpperCase());
      console.log('Normalized URL category:', normalizedParam);
      const matchingCategory = categories.find(cat => 
        cat.trim().toLowerCase() === normalizedParam.toLowerCase()
      );
      if (matchingCategory) {
        setSelectedCategory(matchingCategory);
      } else {
        console.warn(`Category "${normalizedParam}" not found in:`, categories);
        setSelectedCategory('All');
      }
    } else {
      // No category in URL, show All
      setSelectedCategory('All');
    }
    setCurrentPage(1);
  }, [params.category, productsArray.length, categories.length]);

  // Filter products based on selectedCategory
  useEffect(() => {
    if (selectedCategory === 'All') {
      setFilteredProducts(productsArray);
      console.log('Filtered (All):', productsArray.length);
    } else {
      const matched = productsArray.filter((p) => 
        p.category && 
        p.category.trim().toLowerCase() === selectedCategory.toLowerCase()
      );
      setFilteredProducts(matched);
      console.log('Matched products:', matched.length, 'for:', selectedCategory);
      if (matched.length === 0) {
        console.warn('No matches for category:', selectedCategory);
      }
    }
    setCurrentPage(1);
  }, [selectedCategory, productsArray]);

  const totalProducts = filteredProducts.length;
  const totalPages = Math.ceil(totalProducts / productsPerPage);
  const currentProducts = filteredProducts.slice(
    (currentPage - 1) * productsPerPage,
    currentPage * productsPerPage
  );

  const handleCategoryChange = (category) => {
    console.log('Dropdown selected category:', category); // Debug
    setSelectedCategory(category);
    // Update URL to match
    let newUrl = '/products';
    if (category !== 'All') {
      newUrl += `/${encodeURIComponent(category)}`;
    }
    window.history.replaceState({}, '', newUrl);
  };

  const handleProductClick = (product) => {
    setSelectedProduct(product);
  };

  const handleClosePopup = () => {
    setSelectedProduct(null);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  if (loading) {
    return (
      <Fragment>
        <NavbarS3 hclass={'wpo-site-header wpo-header-style-2'} Logo={Logo} />
        <PageTitle pageTitle={t('products')} pagesub={t('products')} />
        <section className="wpo-shop-section section-padding text-center">
          <p>Бүтээгдэхүүнүүдийг ачаалж байна...</p>
        </section>
        <Footer hclass={'wpo-site-footer'} />
        <Scrollbar />
      </Fragment>
    );
  }

  if (error) {
    return (
      <Fragment>
        <NavbarS3 hclass={'wpo-site-header wpo-header-style-2'} Logo={Logo} />
        <PageTitle pageTitle={t('products')} pagesub={t('products')} />
        <section className="wpo-shop-section section-padding text-center">
          <div className="alert alert-warning">{error}</div>
        </section>
        <Footer hclass={'wpo-site-footer'} />
        <Scrollbar />
      </Fragment>
    );
  }

  const pageSubTitle = selectedCategory === 'All' ? t('products') : selectedCategory;

  return (
    <Fragment>
      <NavbarS3 hclass={'wpo-site-header wpo-header-style-2'} Logo={Logo} />
      <PageTitle pageTitle={t('products')} pagesub={pageSubTitle} />
      <section className="wpo-shop-section section-padding">
        <div className="container">
          <div className="category-filter mb-4">
            <h4 style={{ color: 'white' }}>{t('Productspage.select')}</h4>
            <select
              value={selectedCategory}
              onChange={(e) => handleCategoryChange(e.target.value)}
              className="form-control"
              style={{ maxWidth: '300px' }}
            >
              {categories.map((category, i) => (
                <option key={i} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>

          {totalProducts === 0 ? (
            <div className="text-center py-5">
              <h3>Бүтээгдэхүүн олдсонгүй</h3>
              {selectedCategory !== 'All' && (
                <p>Категори: {selectedCategory}. Шалгана уу эсвэл бүх бүтээгдэхүүнийг үзнэ үү.</p>
              )}
            </div>
          ) : (
            <>
              <ShopProduct
                products={currentProducts}
                onProductClick={handleProductClick}
                addToCartProduct={addToCart}
              />
              {totalPages > 1 && (
                <div className="pagination mt-4 text-center">
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                    <button
                      key={page}
                      className={`btn mx-1 ${currentPage === page ? 'theme-btn-primary' : 'theme-btn-s2'}`}
                      onClick={() => handlePageChange(page)}
                    >
                      {page}
                    </button>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </section>

      {selectedProduct && (
        <PopupQuickview
          product={selectedProduct}
          addToCart={addToCart}
          handleCloseClick={handleClosePopup}
        />
      )}

      <Footer hclass={'wpo-site-footer'} />
      <Scrollbar />
      <MessengerChatButton />
    </Fragment>
  );
};

export default connect(null, { addToCart })(ShopPage);